// Version : 1.0.0
// Author : AGALYA

const SignatureActionType = {
	/** ***************** upload Signature Start ************************/
	UPLOAD_SIGNATURE_START: 'upload_signature_start',
	UPLOAD_SIGNATURE_SUCCESS: 'upload_signature_success',
	UPLOAD_SIGNATURE_FAILURE: 'upload_signature_failure',
	UPLOAD_SIGNATURE_RESPONSE_REST_START: 'upload_signature_response_reset_start',
	UPLOAD_SIGNATURE_RESPONSE_CHANGED: 'upload_signature_response_changed',
	/** ***************** upload Signature End ************************/
};

export default SignatureActionType;
